import React, { useState } from "react";
import { message, Tag as ElementTag } from "antd";

import Icon from "../common/Icon";
import Avatar from "../common/Avatar";
import api from "../../services/api";
import { goalsStatus } from "../common/text/Status";
import InputField from "../common/forms/InputField";
import Button from "../common/Button";
import RemoveAlert from "../common/RemoveAlert";
import UserPopover from "../priorities/UserPopover";
import Tag from "../tags/Tag";
import PriorityBody from "./PriorityBody";
import ActionsMenu from "../common/ActionsMenu";
import TrailingIcons from "../common/TrailingIcons";

export default function PriorityItem({
  index,
  onUpdate,
  data,
  mutatePriorityItems,
  reduced = false,
}) {
  const [editing, setEditing] = useState(false);

  const handlePatch = async (values) => {
    try {
      const { data: res } = await api.patch(
        `/weekly_priorities/${data.id}/`,
        values
      );
      onUpdate(res);
    } catch {
      message.error("Parece que houve um erro, tente novamente mais tarde!");
    }
  };

  const handleBlur = async (e) => {
    if (e.target.value.length > 0 && e.target.value !== data.title) {
      await handlePatch({ title: e.target.value });
      setEditing(false);
    }
  };

  const handleDelete = () => {
    RemoveAlert({
      customTitle: "Você tem certeza que deseja remover este foco da semana?",
      continueCallback: async () => {
        try {
          await api.delete(`/weekly_priorities/${data.id}/`);
          onUpdate(data.id, true);
        } catch {
          message.error(
            "Parece que houve um erro, tente novamente mais tarde!"
          );
        }
      },
    });
  };

  const handleEnter = (e) => {
    if (e.keyCode === 13) e.target.blur();
  };

  return (
    <div className="d:f a-i:c">
      <div className="m-r:1">
        <Avatar className="bg-primary text-white">{index}</Avatar>
      </div>
      {editing ? (
        <InputField
          defaultValue={data.title}
          onBlur={handleBlur}
          autoFocus
          onKeyUp={handleEnter}
        />
      ) : (
        <PriorityBody className="pos:r">
          <h6
            className="d:i-b f-w:400 f:1 cur:p"
            onClick={() => setEditing(true)}
          >
            {data.title}
          </h6>
          {!editing && data?.tags && (
            <div className="d:i-b m-l:.7">
              {data?.tags?.map((tag) => (
                <Tag color={tag.color} text={tag.name} />
              ))}
            </div>
          )}
          {!editing && data?.status && (
            <ElementTag
              color={goalsStatus[data.status].color}
              className="text-white m-l:1"
            >
              {goalsStatus[data.status].label}
            </ElementTag>
          )}
          {!editing && (
            <TrailingIcons className="d:i-b" shortcuts={data?.shortcuts} />
          )}
          {!editing && (
            <div className="pos:a right:.8 abs-a-y">
              {!reduced && (
                <UserPopover
                  objUsers={data.assigned_to}
                  onUpdate={({ users }) => handlePatch({ assigned_to: users })}
                />
              )}
              <ActionsMenu
                reduced={reduced}
                onDelete={handleDelete}
                onUpdate={handlePatch}
                data={data}
                dataType="WEEKLY_PRIORITY"
                mutate={mutatePriorityItems}
              />
            </div>
          )}
        </PriorityBody>
      )}

      {!editing && !reduced && (
        <div className="m-l:.5">
          {["IN_PROGRESS", "SUCCESS", "FAILED"].map(
            (k) =>
              data.status !== k && (
                <Button
                  className="m-l:.5"
                  type="white"
                  shape="circle"
                  icon={
                    <Icon type={k} style={{ color: goalsStatus[k].color }} />
                  }
                  onClick={() => handlePatch({ status: k })}
                />
              )
          )}
        </div>
      )}
    </div>
  );
}
